import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {withValues} from 'utils/object';
import {request} from 'utils/request-axios';
import {TeamNotificationEmployeeEditFormData} from './types';

type PossibleResponses =
    | Api.Response.RedirectAxios<'notifications_employee_view'>
    | Api.Response.RedirectAxios<'notifications_view'>;

const useEditTeamNotificationEmployee = (): UseMutationResult<
    PossibleResponses,
    Error,
    {
        formData: TeamNotificationEmployeeEditFormData;
        mid: string;
    }
> => {
    const locale = useLocale();

    return useMutation(({formData, mid}) =>
        request({
            formData: withValues(formData),
            locale,
            method: 'POST',
            url: `/ui/team/notification/employee/${mid}/edit/`,
        }),
    );
};

export default useEditTeamNotificationEmployee;
